import { resources } from '@lista/i18n';
import { RTL_LOCALES, type Locale } from '@lista/shared-types';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { preferenceStorage } from '../shared/privacy/consent';

const STORAGE_KEY = 'lista.locale';

function initialLocale(): Locale {
  const stored = preferenceStorage.getItem(STORAGE_KEY);
  if (stored === 'en' || stored === 'ar') return stored;
  const fromEnv = import.meta.env.VITE_DEFAULT_LOCALE;
  if (fromEnv === 'ar' || fromEnv === 'en') return fromEnv;
  return navigator.language.toLowerCase().startsWith('ar') ? 'ar' : 'en';
}

function applyDocumentLocale(locale: Locale) {
  document.documentElement.lang = locale;
  document.documentElement.dir = RTL_LOCALES.includes(locale) ? 'rtl' : 'ltr';
}

/** Catalogs come from @lista/i18n (shared with the mobile app). */
export function initI18n() {
  const lng = initialLocale();
  void i18n.use(initReactI18next).init({
    resources,
    lng,
    fallbackLng: 'en',
    interpolation: { escapeValue: false }, // React escapes output
  });
  applyDocumentLocale(lng);
}

export function setLocale(locale: Locale) {
  preferenceStorage.setItem(STORAGE_KEY, locale);
  void i18n.changeLanguage(locale);
  applyDocumentLocale(locale);
}
